export const UPDATE_ACTIVE_STAGE_INDEX = "UPDATE_ACTIVE_STAGE_INDEX";
export const UPDATE_FIELD = "UPDATE_FIELD";
export const ADD_FIELD = "ADD_FIELD";
export const REMOVE_FIELD = "REMOVE_FIELD";
export const ADD_STAGE = "ADD_STAGE";
export const REMOVE_STAGE = "REMOVE_STAGE";
export const POPULATE_KEYWORDS = "POPULATE_KEYWORDS";
export const UPDATE_MODE = "UPDATE_MODE";
export const UPDATE_KEYWORDS = "UPDATE_KEYWORDS";
export const FETCHING_KEYWORDS = "FETCHING_KEYWORDS";
export const FETCHED_KEYWORDS = "FETCHED_KEYWORDS";
export const UPDATE_BASE_TABLE = "UPDATE_BASE_TABLE";
export const UPDATE_ORG_ID = "UPDATE_ORG_ID";
export const RESET_ORG_ID = "RESET_ORG_ID";
export const CREATE_INITIAL_STATE = "CREATE_INITIAL_STATE";
export const UPDATE_STATE_LOADING = "UPDATE_STATE_LOADING";
export const UPDATE_STAGE_KEYS = "UPDATE_STAGE_KEYS";
export const UPDATE_FIELD_DROPDOWN_VALUES = "UPDATE_FIELD_DROPDOWN_VALUE";
export const UPDATE_DEPENDENT_FIELD_VALUES = "UPDATE_DEPENDENT_FIELD_VALUES";
export const UPDATE_SINGLE_FIELD_DROPDOWN_VALUES = "UPDATE_SINGLE_FIELD_DROPDOWN_VALUES";
export const UPDATE_TABLES = "UPDATE_TABLES";
export const UPDATE_CUSTOM_DROPDOWN_DATA = "UPDATE_CUSTOM_DROPDOWN_DATA";
export const UPDATE_LAST_EXECUTED_STAGE = "UPDATE_LAST_EXECUTED_STAGE";
export const UPDATE_IS_VALID_FLAG = "UPDATE_IS_VALID_FLAG";
export const FLUSH_QUERY = "FLUSH_QUERY";
export const UPDATE_QID = "UPDATE_QID";
export const UPDATE_STAGES_MODEL = "UPDATE_STAGES_MODEL";
